import HCLDX from "@system/config/hcldx";
import Helper from "../../src/support/Helper";
import Constants from "src/support/Constants";

class CheckOut {
    static GET_PAYMENT_METHOD = Helper.getCartUrl() + '/api/paymentmethod/list';

    static getCheckOutRouteURL() {
        return HCLDX.baseURL() + '/shop/check-out';
    }

    static getCheckOutStatusRouteURL(checkoutFrom = Constants.systemModules.CART) {
        if (checkoutFrom === Constants.systemModules.Quote) {
            return HCLDX.baseURL() + '/shop/quote-order-confirmation';
        }
        return HCLDX.baseURL() + '/shop/order-confirmation';

    }
}

export default CheckOut;